import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger)

const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

// Thêm class lenis vào html để CSS có thể detect
document.documentElement.classList.add('lenis');

if (!isTouchDevice()) {
  // Desktop: Full Lenis
  const lenis = new Lenis({
    smooth: true,
    duration: 3,
    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    smoothTouch: false,
    gestureOrientation: 'vertical',
    normalizeWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.2,
  });

  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  window.lenis = lenis;

} else {
  // Touch: Native scroll với throttled ScrollTrigger
  document.documentElement.classList.add('lenis-touch');

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        ScrollTrigger.update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Mock lenis
  window.lenis = {
    scrollTo: (target, options = {}) => {
      const element = typeof target === 'string' ? document.querySelector(target) : target;
      if (element) {
        element.scrollIntoView({
          behavior: options.immediate ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    },
    start: () => {},
    stop: () => {},
    destroy: () => {}
  };
}

gsap.ticker.lagSmoothing(0);